import React, { HTMLAttributes, useEffect, useState } from 'react';
import ClipIcon from '../../../ClipIcon';
import useSignLease from '../../../../context';
import classNames from 'classnames';
import Link from 'next/link';
import Typography from '../../../../../../../components/generics/texts/Typography';
import classes from './index.module.scss';
import useFetchContentByIds from '../../../../../../../hooks/requests/content/useFetchContentByIds';
import { LEASE_SUMMARY } from '../../../../../../../consts/idsContent';
import moment from 'moment';
import EditIcon from './compoments/EditIcon';
import DateSelection from './compoments/DateSelection';
import PropertyHeder from './compoments/PropertyHeader';

const initContent = {
  contentId: LEASE_SUMMARY,
  title: 'Lease Summary',
  subtitle: 'Lease agreement',
  body: 'Auto pay agreement',
  info: 'https://made-with-love.landa.app/05-17-2021/landa_autopay.pdf',
};

const LeaseSummaryBox = ({ className }: HTMLAttributes<HTMLDivElement>) => {
  const [innerContent, setInnerContent] = useState(initContent);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data, startDate, endDate, daysInFirstMonth, firstMonthRent } =
    useSignLease();
  const { content } = useFetchContentByIds([LEASE_SUMMARY]);
  useEffect(() => {
    const fetchedContent = content?.contents?.find(
      (item: any) => item.contentId === LEASE_SUMMARY
    );
    if (fetchedContent) setInnerContent(fetchedContent);
  }, [content]);

  const formatDate = (dateString: string) =>
    moment(dateString).format('MM/DD/YYYY');
  const formatMonth = (dateString: string) => moment(dateString).format('MMMM');

  const { address, photos, onMarketLease } = data!.units[0];
  const addressParts = address.split(', ');
  const addressLine = addressParts[0];
  const cityLine = `${addressParts[1]} ${addressParts[2]}`;
  const totalAmount =
    onMarketLease.securityDepositAmountAmount.toLocaleString();

  return (
    <div className={classNames(classes.container, className)}>
      <Typography className={classes.title}>{innerContent.title}</Typography>
      <PropertyHeder />
      <div className={classes.detailsRow}>
        <Typography className={classes.label}>Term</Typography>
        {isModalOpen ? (
          <DateSelection onClose={() => setIsModalOpen(false)} />
        ) : (
          <div
            className={classes.redactedValue}
            onClick={() => setIsModalOpen(true)}
          >
            <Typography className={classes.valueBold}>
              {formatDate(startDate || '')} - {formatDate(endDate || '')}
            </Typography>
            <EditIcon />
          </div>
        )}
      </div>
      <div className={classes.detailsRow}>
        <Typography className={classes.label}>Monthly Rent</Typography>
        <Typography className={classes.value}>
          ${onMarketLease.monthlyRentAmount.toLocaleString()}
        </Typography>
      </div>
      <div className={classes.detailsRow}>
        <Typography className={classes.label}>Reservation Fee</Typography>
        <Typography className={classes.value}>
          ${onMarketLease.securityDepositAmountAmount.toLocaleString()}
        </Typography>
      </div>
      <div className={classes.detailsRow}>
        <Typography className={classes.label}>
          {`${formatMonth(startDate || '')} rent (${daysInFirstMonth} ${
            daysInFirstMonth > 1 ? 'days' : 'day'
          })`}
        </Typography>
        <Typography className={classes.value}>
          ${firstMonthRent.toLocaleString()}
        </Typography>
      </div>

      <div className={classes.totalRow}>
        <Typography className={classes.totalRowTitle}>Total</Typography>
        <Typography className={classes.totalRowValue}>
          ${totalAmount}
        </Typography>
      </div>
      <div className={classes.agreements}>
        <Link
          href={onMarketLease.proposedLease || ''}
          target="_blank"
          className={classNames(classes.agreementItem, className)}
        >
          <div className={classes.boxIcon}>
            <ClipIcon className={classes.icon} />
          </div>
          <Typography>{innerContent.subtitle}</Typography>
        </Link>

        <Link
          href={innerContent.info}
          target="_blank"
          className={classNames(classes.agreementItem, className)}
        >
          <div className={classes.boxIcon}>
            <ClipIcon className={classes.icon} />
          </div>
          <Typography>{innerContent.body}</Typography>
        </Link>
      </div>
    </div>
  );
};

export default LeaseSummaryBox;
